// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__29R2k","closeBtn":"style_closeBtn__2792p","Inputs":"style_Inputs__2JqHt","errorMsg":"style_errorMsg__2lwro","Btns":"style_Btns__3kY0_"};